"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRouterReducer = void 0;
var actions_1 = require("./actions");
var createRouterReducer = function (_a) {
    var _b = _a.savePreviousLocations, savePreviousLocations = _b === void 0 ? 0 : _b, basename = _a.basename;
    var initialState = {
        location: null,
        action: null,
        basename: basename,
    };
    // eslint-disable-next-line no-restricted-globals
    var numLocationToTrack = isNaN(savePreviousLocations) ? 0 : savePreviousLocations;
    if (numLocationToTrack)
        initialState.previousLocations = [];
    return function (state, _a) {
        if (state === void 0) { state = initialState; }
        var _b = _a === void 0 ? {} : _a, type = _b.type, payload = _b.payload;
        if (type === actions_1.LOCATION_CHANGE) {
            var _c = (payload || {}), location_1 = _c.location, action = _c.action;
            var previousLocations = numLocationToTrack // @ts-ignore
                ? __spreadArray([{ location: location_1, action: action }], state.previousLocations.slice(0, numLocationToTrack), true) : undefined;
            return __assign(__assign({}, state), { location: location_1, action: action, previousLocations: previousLocations });
        }
        return state;
    };
};
exports.createRouterReducer = createRouterReducer;
//# sourceMappingURL=reducer.js.map